import { getErrorMessage, logoutUser } from '@/shared/lib'
import { DelayedPromise, refreshAccessToken } from './apiClient'
import { maxRequestRetry } from './apiConstants'

export const handle401Error = async () => {
    const retryFactorScale = 2.7
    const retryMillis = 1000

    for (let retryCounter = 0; retryCounter < maxRequestRetry; retryCounter++) {
        const delayMillis = retryCounter * retryFactorScale * retryMillis
        await new Promise((resolve) => setTimeout(resolve, delayMillis))

        try {
            const newAccessToken = await refreshAccessToken()
            if (newAccessToken) {
                return newAccessToken
            } else {
                logoutUser()

                break
            }
        } catch (error) {
            getErrorMessage('handle401Error', error)
            throw error
        }
    }

    getErrorMessage('handle401Error', 'Sign in failed after multiple attempts')
    return false
}

export const handleHttpErrorRetry = async (
    url: string,
    requestData: {
        method: string
        body: string | null
        headers: { 'Content-type': string }
    },
    maxRetryCount: number
) => {
    let jsonData
    let response

    for (let retryCounter = 0; retryCounter < maxRetryCount; retryCounter++) {
        try {
            response = await fetch(url, requestData)

            if (response.ok) {
                jsonData = await response.json()
                return jsonData
            } else {
                throw new Error(`HTTP error: ${response.status}`)
            }
        } catch (error: unknown) {
            if (retryCounter >= maxRetryCount - 1) {
                throw new Error('Failed to fetch data after multiple attempts')
            }

            await DelayedPromise(1000)
        }
    }

    throw new Error('Unexpected error in handleHttpErrorRetry function')
}
